/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import { useState, useEffect, useRef } from 'react';
import { getLayerManager } from '../services/layerManagerInstance';
import { UndergroundLayer } from '../types/underground';

export function useLayerState() {
  const layerManager = useRef(getLayerManager()).current;
  const [activeLayer, setActiveLayer] = useState<UndergroundLayer>(
    layerManager.getCurrentState().currentLayer
  );
  const [layerVisibility, setLayerVisibility] = useState(
    layerManager.getCurrentState().visibility
  );
  useEffect(() => {
    return layerManager.subscribe((state) => {
      setActiveLayer((prev) =>
        prev === state.currentLayer ? prev : state.currentLayer
      );
      setLayerVisibility(state.visibility);
    });
  }, [layerManager]);

  return { layerManager, activeLayer, layerVisibility };
}